import { useEffect, useRef } from "react";

interface UseAutoAssignEntityParams {
    entityId: number | null;
    currentEntityId: number | null | undefined;
    onAssign: (entityId: number) => void;
    isBlocked?: boolean;
    canAutoAssign?: boolean;
}

export function useAutoAssignEntity({
    entityId,
    currentEntityId,
    onAssign,
    isBlocked = false,
    canAutoAssign = true,
}: UseAutoAssignEntityParams) {
    const lastAssignedEntityIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (
            isBlocked ||
            !canAutoAssign ||
            currentEntityId != null ||
            entityId == null ||
            entityId === lastAssignedEntityIdRef.current
        ) {
            return;
        }

        lastAssignedEntityIdRef.current = entityId;
        onAssign(entityId);
    }, [canAutoAssign, currentEntityId, isBlocked, onAssign, entityId]);
}
